<template>
	<svg width="56" height="56" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
	</svg>
</template>
